var _rect, _text, _rect2, _circle, _text2, _text3, _text4, _path, _rect3, _circle2, _text5, _text6, _text7, _path2, _rect4, _circle3, _text8, _text9, _text0, _path3, _rect5, _circle4, _text1, _text10, _text11, _rect6, _circle5, _text12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomDevelopmentDiscoveryMappingWorkspaceMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 360,
    height: 570,
    viewBox: "0 0 360 570",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Discovery and process mapping workflow") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 358,
    height: 568,
    rx: 27,
    fill: "#EEF5FC",
    stroke: "#BED7EE"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 28,
    y: 39,
    fill: "#087CFF",
    textAnchor: "start",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 10,
    fontWeight: 850,
    letterSpacing: 1.5
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 28,
    dy: 0
  }, "DISCOVERY WORKSPACE"))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 65,
    width: 312,
    height: 91,
    rx: 17,
    fill: "#FFFFFF",
    fillOpacity: 0.92,
    stroke: "#D2E1F2"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 92,
    r: 13,
    fill: "#087CFF",
    fillOpacity: 0.13,
    stroke: "#087CFF"
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 51,
    y: 96,
    textAnchor: "middle",
    fill: "#087CFF",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 9,
    fontWeight: 850
  }, "01")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 74,
    y: 96,
    fill: "#07152A",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 14,
    fontWeight: 820
  }, "Observe")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 42,
    y: 126,
    fill: "#536985",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 10,
    fontWeight: 620
  }, "See the work in its real operating context.")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M180 156v24",
    stroke: "#087CFF",
    strokeWidth: 2,
    strokeDasharray: "4 5"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 181,
    width: 312,
    height: 91,
    rx: 17,
    fill: "#FFFFFF",
    fillOpacity: 0.92,
    stroke: "#D2E1F2"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 208,
    r: 13,
    fill: "#FF2775",
    fillOpacity: 0.13,
    stroke: "#FF2775"
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 51,
    y: 212,
    textAnchor: "middle",
    fill: "#FF2775",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 9,
    fontWeight: 850
  }, "02")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 74,
    y: 212,
    fill: "#07152A",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 14,
    fontWeight: 820
  }, "Map")), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 42,
    y: 242,
    fill: "#536985",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 10,
    fontWeight: 620
  }, "Trace data, handovers and decision points.")), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M180 272v24",
    stroke: "#087CFF",
    strokeWidth: 2,
    strokeDasharray: "4 5"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 297,
    width: 312,
    height: 91,
    rx: 17,
    fill: "#FFFFFF",
    fillOpacity: 0.92,
    stroke: "#D2E1F2"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 324,
    r: 13,
    fill: "#30D6A1",
    fillOpacity: 0.13,
    stroke: "#30D6A1"
  })), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 51,
    y: 328,
    textAnchor: "middle",
    fill: "#30D6A1",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 9,
    fontWeight: 850
  }, "03")), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 74,
    y: 328,
    fill: "#07152A",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 14,
    fontWeight: 820
  }, "Measure")), _text0 || (_text0 = /*#__PURE__*/React.createElement("text", {
    x: 42,
    y: 358,
    fill: "#536985",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 10,
    fontWeight: 620
  }, "Quantify delay, effort, risk and opportunity.")), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M180 388v24",
    stroke: "#087CFF",
    strokeWidth: 2,
    strokeDasharray: "4 5"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 413,
    width: 312,
    height: 91,
    rx: 17,
    fill: "#FFFFFF",
    fillOpacity: 0.92,
    stroke: "#D2E1F2"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 440,
    r: 13,
    fill: "#F4B63D",
    fillOpacity: 0.13,
    stroke: "#F4B63D"
  })), _text1 || (_text1 = /*#__PURE__*/React.createElement("text", {
    x: 51,
    y: 444,
    textAnchor: "middle",
    fill: "#F4B63D",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 9,
    fontWeight: 850
  }, "04")), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 74,
    y: 444,
    fill: "#07152A",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 14,
    fontWeight: 820
  }, "Define")), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 42,
    y: 474,
    fill: "#536985",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 10,
    fontWeight: 620
  }, "Shape the first high-value system scope.")), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 521,
    width: 312,
    height: 32,
    rx: 10,
    fill: "#07152A"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 537,
    r: 5,
    fill: "#30D6A1"
  })), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    x: 58,
    y: 541,
    fill: "#FFFFFF",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 9,
    fontWeight: 800,
    letterSpacing: 0.4
  }, "OUTPUT: EVIDENCE-BASED SYSTEM BRIEF")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomDevelopmentDiscoveryMappingWorkspaceMobile);
export default __webpack_public_path__ + "static/media/custom-development-discovery-mapping-workspace-mobile.fd9ce6852656110553caf9f5506c87fe.svg";
export { ForwardRef as ReactComponent };